import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

const apiErrors = {};

const firebaseErrors = {
  "permission-denied": "沒有權限進行此操作",
  "deadline-exceeded": "連線逾時，請檢查網路連線速度"
};

const parser = e => {
  if (!isEmpty(get(e, "response.data.message"))) {
    return get(e, "response.data.message");
  }

  if (!isEmpty(get(e, "code"))) {
    return firebaseErrors[get(e, "code")];
  }

  if (!isEmpty(get(e, "message"))) {
    console.log(get(e, "message"), "---");
    return get(e, "message");
  }

  return "未知錯誤，請稍後再試";
};

export default parser;
